<template>
  <div class="pagination">
    <select class="pagination__per-page" v-model="perPage_">
      <option value="10">10 per page</option>
      <option value="50">50 per page</option>
      <option value="100">100 per page</option>
    </select>
    <button @click="goToFirstPage" :disabled="disabled">
      <font-awesome-icon icon="angle-double-left" title="Go to first page" />
    </button>
    <button @click="goBackOnePage" :disabled="disabled || currentPage === 1">
      <font-awesome-icon icon="angle-left" title="Go to previous page" />
    </button>
    <input
      class="pagination__pages"
      type="number"
      min="1"
      :max="pages"
      :disabled="disabled"
      v-model="page"
    />
    <span>of {{ pages }}</span>
    <button
      @click="goForwardOnePage"
      :disabled="disabled || currentPage === pages"
    >
      <font-awesome-icon icon="angle-right" title="Go to next page" />
    </button>
    <button @click="goToLastPage" :disabled="disabled">
      <font-awesome-icon icon="angle-double-right" title="Go to last page" />
    </button>
  </div>
</template>
<script>
export default {
  name: "Pagination",
  props: {
    currentPage: Number,
    rowCount: Number,
    perPage: Number,
    disabled: Boolean
  },
  data() {
    return {
      //
    };
  },
  methods: {
    goToFirstPage() {
      this.goToPage(1);
    },
    goToLastPage() {
      this.goToPage(this.pages);
    },
    goBackOnePage() {
      this.goToPage(this.page - 1);
    },
    goForwardOnePage() {
      this.goToPage(this.page + 1);
    },
    goToPage(p) {
      if (p < 1) p = 1;
      if (p > this.pages) p = this.pages;
      this.$emit("pageChanged", p);
    },
    setPerPage(p) {
      this.$emit("perPageChanged", p);
      this.goToPage(1);
    }
  },
  computed: {
    pages: function() {
      return Math.max(1, Math.ceil((1.0 * this.rowCount) / this.perPage_));
    },
    page: {
      get() {
        return this.currentPage;
      },
      set(value) {
        this.goToPage(parseInt(value));
      }
    },
    perPage_: {
      get() {
        return this.perPage;
      },
      set(value) {
        this.setPerPage(parseInt(value));
      }
    }
  }
};
</script>
<style scoped>
.pagination {
  display: flex;
  justify-content: end;
  text-wrap: nowrap;
}
.pagination span {
  background-color: buttonface;
  border-top: 1px solid rgb(118, 118, 118);
  border-bottom: 1px solid rgb(118, 118, 118);
  padding-left: 2px;
  padding-right: 2px;
  padding-top: 1px;
  padding-bottom: 1px;
}
.pagination button {
  border: 1px solid rgb(118, 118, 118);
  border-right: none;
}
.pagination button:last-of-type {
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  border-right: 1px solid rgb(118, 118, 118);
}
.pagination button:focus,
.pagination input:focus,
.pagination select:focus {
  outline: rgba(102, 179, 227, 0.75) auto 1px !important;
  outline-offset: 0px;
  z-index: 99;
}
.pagination__per-page {
  border-right: none;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
  background-color: white;
}
.pagination__pages {
  text-align: right;
  border: 1px solid rgb(118, 118, 118);
}
</style>
